import {Component, ElementRef, OnDestroy, OnInit, ViewChild} from '@angular/core';
import {ExportFile} from '../../../_models/export.file.model';
import {CrisisAlertService} from '../../services/crisis-alert.service';
import {Observable} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {DownloadDialogComponent} from '../download-dialog/download-dialog.component';
import {AuthenticationService} from '../../../core/services/authentication.service';
import {User} from '../../../_models/user.model';
import {DownloadMiniDialogComponent} from '../download-mini-dialog/download-mini-dialog.component';
import { Constants } from '../../constants';

export interface DialogData {
  urls: string[];
  name: string;
}

@Component({
  selector: 'app-export-file-list',
  templateUrl: './export-file-list.component.html',
  styleUrls: ['./export-file-list.component.scss']
})
export class ExportFileListComponent implements OnInit, OnDestroy {
  today: number = Date.now();
  files: Observable<ExportFile[]>;
  page = 1;
  pageSize = 20;
  currentFiles: ExportFile[];
  whiteCoverDisabled: boolean;
  token: any;
  @ViewChild('selectAllBox', {static: false}) private selectAllBox: ElementRef;
  private user: User;
  selectedCount: number;

  constructor(
    private crisisAlertService: CrisisAlertService,
    public dialog: MatDialog
  ) {
  }

  ngOnInit() {
    this.files = this.crisisAlertService.filesObs;
    this.files.subscribe(files => {
      this.currentFiles = files;
    });
    this.user = JSON.parse(sessionStorage.getItem(Constants.AUTH_TOKEN));
    this.crisisAlertService.downloadSearchTriggerObs.subscribe(isTrigger => {
      if (isTrigger) {
        this.resetList();
      }
    });
  }

  resetList(): void {
    this.page = 1;
    this.whiteCoverDisabled = false;
    this.selectedCount = 0;
    if (this.selectAllBox && this.selectAllBox.nativeElement) {
      this.selectAllBox.nativeElement.checked = false;
    }
  }

  addToDownloadList(event: any, item: ExportFile) {
    if (event.currentTarget.checked) {
      item.checked = true;
      if (!this.whiteCoverDisabled) {
        this.whiteCoverDisabled = true;
      }
    } else {
      item.checked = false;
      // check any one checked remaining
      let anyOneCheck = false;
      for (const file of this.currentFiles) {
        if (file.checked) {
          anyOneCheck = true;
          break;
        }
      }
      this.whiteCoverDisabled = anyOneCheck;
    }
    this.performCountCheck();
  }

  private performCountCheck() {
    let count = 0;
    for (const file of this.currentFiles) {
      if (file.checked) {
        count++;
      }
    }
    this.selectedCount = count;
  }

  pageSizePublish() {

  }

  pageNumPublish() {

  }

  selectAll(event: any) {
    if (this.currentFiles.length > 0) {
      if (event.currentTarget.checked) {
        for (const file of this.currentFiles) {
          file.checked = true;
        }
        this.whiteCoverDisabled = true;
      } else {
        for (const file of this.currentFiles) {
          file.checked = false;
        }
        this.whiteCoverDisabled = false;
      }
      this.crisisAlertService.pushFiles(this.currentFiles);
      this.selectedCount = this.currentFiles.length;
    } else {
      if (event.currentTarget.checked) {
        event.currentTarget.checked = false; // unchecked if no result
      }
    }
  }

  downloadAll() {
    this.openDialog('Initializing ...', null);
    const urls = [];
    let count = 0;
    for (const file of this.currentFiles) {
      if (file.checked) {
        file.userId = '' + this.user.userId;
        this.crisisAlertService.addAuditInfoForDownloadFile(file);
        this.crisisAlertService.getFileFromS3(file.filePath)
          .subscribe(tempUrl => {
            urls.push(tempUrl);
          });
        count++;
      }
    }
    console.log('Files count=' + count);
    setTimeout(() => {
      console.log('Urls count=' + urls.length);
      this.dialog.closeAll();
      this.openDialog(null, urls);
    }, count * 400);

  }

  download(file: ExportFile) {
    file.userId = '' + this.user.userId;
    this.crisisAlertService.addAuditInfoForDownloadFile(file);
    this.crisisAlertService.getFileFromS3(file.filePath)
      .subscribe(signedUrl => {
        const dialogRef = this.dialog.open(DownloadMiniDialogComponent, {
          width: '10px',
          data: {target: '_self', url: signedUrl}
        });
        dialogRef.afterClosed().subscribe(result => {
          console.log('mini dialog closed');
        });
      });
  }

  openDialog(name: string, urls: string[]): void {
    const dialogRef = this.dialog.open(DownloadDialogComponent, {
      width: '450px',
      data: {name: name, urls: urls}
    });

    dialogRef.afterClosed().subscribe(result => {
      this.whiteCoverDisabled = false;
      if (this.selectAllBox && this.selectAllBox.nativeElement) {
        this.selectAllBox.nativeElement.checked = false;
      }
      this.crisisAlertService.searchExportFiles(this.crisisAlertService.fileSearchQuerySub.getValue());
    });
  }

  ngOnDestroy(): void {
    this.crisisAlertService.pushFiles(null);
  }
}
